import { render } from "./TargetPorfolioTable.vue?vue&type=template&id=14e5a633&scoped=true"
import script from "./TargetPorfolioTable.vue?vue&type=script&lang=js"
export * from "./TargetPorfolioTable.vue?vue&type=script&lang=js"

import "./TargetPorfolioTable.vue?vue&type=style&index=0&id=14e5a633&lang=scss&scoped=true"

import exportComponent from "/tmp/build_0358080b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14e5a633"]])

export default __exports__